import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesOverview from "./components/ServicesOverview";
import AIAnswerBlock from "../../components/feature/sections/AIAnswerBlock";
import ProcessSection from "../../components/feature/sections/ProcessSection";
import WhyChooseUs from "../../components/feature/sections/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/sections/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/sections/TestimonialsSection";
import FAQSection from "../../components/feature/sections/FAQSection";
import FinalCTA from "../../components/feature/sections/FinalCTA";

export default function HomePage() {
  return (
    <div className="font-body">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesOverview />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreasSection />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
